/**
 * Bug in jQuery.trim().
 * @see http://bugs.jquery.com/ticket/6868
 * @param str
 * @return {String|XML}
 */
store.admin.trim = function(str) {
	return str.replace(/^\s+/, '').replace(/\s+$/, '');
};

store.admin.elementGetStringVal = function(element) {
	var t = $(element);
	var type = t.attr("type");
	var d = null;
	if (type == 'radio' || type == "checkbox") {
		d = (t.attr("checked")) ? "true" : '';
	}
	else {
		d = t.val();
	}
	if ($.isArray(d)) {
		d = t.val().join(',');
	}
	if (d) {
		// Tinymce hack
		if (d == '<p><br /></p>') d = '';
		d = store.admin.trim(d);
	}
	return d;
};
store.admin.taxCalculate = function(value, taxRate) {
	return value * (1+(taxRate/100));
};

store.admin.taxCalculateReverse = function(value, taxRate) {
	return value / (1+(taxRate/100));
};
store.admin.numDecimalsDetailed = 4;
store.admin.floatFormat = function(value) {
	return value.toFixed(store.admin.numDecimalsDetailed);
};
store.admin.parseFloat = function(str) {
	return parseFloat(String(str).replace(',', '.'));
};
store.admin.altRow = function($elements) {
	$elements.each(function(i) {
		var p = $(this).parent();
		p.removeClass("altRow");
		if ((i % 2) === 0) {
			p.addClass("altRow");
		}
	});
};
